module.exports = __webpack_public_path__ + "purple_front.b38d8a25.png";